import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';
import { Filter } from '../models/warranties/filter.model';
import { DealerCorrectionReviewModel } from '../models/warranties/dealer-coorection-review.model';

@Injectable({
    providedIn: 'root'
  })
  export class DealerCorrectionReviewService {
    _dealerCorrectionReviews: Array<DealerCorrectionReviewModel>;
    filter: Filter = new Filter();
    constructor(private httpClient: HttpClient, private authService: AuthService) {
    }

    getHeaders() {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('DWP_TOKEN')
      });
      return {headers};
    }
    
    getDealerCorrectionReviews(id: number): Observable<Array<DealerCorrectionReviewModel>> {
      return this.httpClient.get<Array<DealerCorrectionReviewModel>>(`${environment.baseUrl}/dealercorrection/messages/${id}`, this.getHeaders());
    }

    saveDealerCorrectionReview(dealerCorrectionModel: DealerCorrectionReviewModel): Observable<DealerCorrectionReviewModel> {
        return this.httpClient.post<DealerCorrectionReviewModel>(`${environment.baseUrl}/dealercorrection/sendreview`, 
        dealerCorrectionModel, this.getHeaders());
    }

    public set dealerCorrectionReviews(dealerCorrectionReviews: Array<DealerCorrectionReviewModel>){
        this._dealerCorrectionReviews = dealerCorrectionReviews;
    }
    public get dealerCorrectionReviews(): Array<DealerCorrectionReviewModel>{
        return this._dealerCorrectionReviews;
    }

    isAdmin(): boolean{
      return this.authService.isAdmin();
    }

    userDetails(): string{
      return this.authService.getUser();
    }

    saveSupportingDocument(file: File, warrantyId:number , speacialRequestId: number): Observable<string> {
      const formData: FormData = new FormData();
      formData.append('file', file);
      
      return this.httpClient.post<string>(`${environment.baseUrl}/dealercorrection/savedealerreviewdocument/${warrantyId}/${speacialRequestId}`, formData);
    }

    getSupportingDocument(filename: string){
      return this.httpClient.get(`${environment.baseUrl}/dealercorrection/speacialrequestsdocuments/${filename}`, {
        headers: this.authService.getHeaders(),
        responseType: 'blob'
      }).subscribe((res: any) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(res);
        a.download = filename;
        a.click();
      });
    }
    
}
